import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { RBACProvider, useRBAC } from '@/contexts/RBACContext';
import { LiveChatNotificationProvider } from '@/contexts/LiveChatNotificationContext';
import { NotificationSoundProvider } from '@/contexts/NotificationSoundContext';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import LeadDashboard from '@/pages/LeadDashboard';
import LeadDashboardOverview from '@/pages/LeadDashboardOverview';
import DirectSalesDashboard from '@/pages/DirectSalesDashboard';
import IndirectSalesDashboard from '@/pages/IndirectSalesDashboard';
import BrokerageHub from '@/pages/BrokerageHub/BrokerageHub';
import BrokerageDetail from '@/pages/BrokerageHub/BrokerageDetail';
import DuplicateManagementDashboard from '@/pages/CustomerMaster/DuplicateManagementDashboard';
import FirstLogin from '@/pages/FirstLogin';
import CarRequests from '@/pages/CarRequests';
import ContactsOld from '@/pages/ContactsRedesigned';
import ContactDetail from '@/pages/ContactDetailRedesigned';
import Calling from '@/pages/Calling';
import SocialPublishing from '@/pages/SocialPublishing';
import RevenueForecast from '@/pages/RevenueForecast';
import AICampaignCreator360 from '@/pages/AICampaignCreator360';
import HubSpotMigration from '@/pages/HubSpotMigration';
import RealEstate from '@/pages/RealEstate';
// WorkflowsNew is DEPRECATED - redirecting /workflows to /workflows-builder
import SalesVisits from '@/pages/SalesVisits';
import Settings from '@/pages/Settings';
import Integrations from '@/pages/Integrations';
import TeamManagement from '@/pages/TeamManagement';
import JoinTeam from '@/pages/JoinTeam';
import BrokerMaster from '@/pages/BrokerMaster';
import BrokerDedupWorkspace from '@/pages/BrokerDedupWorkspace';
import LeadLifecycleDashboard from '@/pages/LeadLifecycleDashboard';
import ApprovalInbox from '@/pages/ApprovalInbox';
import Notifications from '@/pages/Notifications';
import DeveloperMaster from '@/pages/DeveloperMaster';
import LeadAssignment from '@/pages/LeadAssignment';
import PaymentSuccess from '@/pages/PaymentSuccess';
import DealAnalyticsPage from '@/pages/DealAnalyticsPage';
import OrganizationManagement from '@/pages/OrganizationManagement';
import OrganizationDashboard from '@/pages/OrganizationDashboard';
import OrganizationModulesManagement from '@/pages/OrganizationModulesManagement';
import CampaignAnalytics from '@/pages/CampaignAnalytics';
import OmnichannelInbox from '@/pages/OmnichannelInbox';
import ChannelSettings from '@/pages/ChannelSettings';
import OrganizationStructure from '@/pages/OrganizationStructure';
import RoleManagement from '@/pages/RoleManagement';
import EnhancedRoleManagement from '@/pages/EnhancedRoleManagement';
import MenuManagement from '@/pages/MenuManagement';
import UserMappingSettings from '@/pages/UserMappingSettings';
import PermissionGroups from '@/pages/PermissionGroups';
import ProfileSettings from '@/pages/ProfileSettings';
import NoAccessPage from '@/pages/NoAccessPage';
import WhatsAppSettings from '@/pages/WhatsAppSettings';
import EmailSettings from '@/pages/EmailSettings';
import SocialAdsSettings from '@/pages/SocialAdsSettings';
import WhatsAppInbox from '@/pages/WhatsAppInbox';
import UserManagement from '@/pages/UserManagement';
import ProjectCatalog from '@/pages/ProjectCatalog';
import SharedProjectView from '@/pages/SharedProjectView';
import SharedDocumentView from '@/pages/SharedDocumentView';
import WorkflowBuilder from '@/pages/WorkflowBuilder';
import WorkflowsListNew from '@/pages/WorkflowsListNew';
import WorkflowHistory from '@/pages/WorkflowHistory';
import WorkflowAnalytics from '@/pages/WorkflowAnalytics';
import LeadStatusManagement from '@/pages/LeadStatusManagement';
import LifecycleStageManagement from '@/pages/LifecycleStageManagement';
import CustomFieldsTagsManagement from '@/pages/CustomFieldsTagsManagement';
import AIAssignmentSettings from '@/pages/AIAssignmentSettings';
import WhatsAppFollowupSettings from '@/pages/WhatsAppFollowupSettings';
import WhatsAppAutomation from '@/pages/WhatsAppAutomation';
import WorkflowDashboard from '@/pages/WorkflowDashboard';
import WhatsAppWorkflowBuilder from '@/pages/WhatsAppWorkflowBuilder';
import SLASettings from '@/pages/SLASettings';
import ResponseTimeTracker from '@/pages/ResponseTimeTracker';
import AIIntelligence from '@/pages/AIIntelligence';
import AISmartAssignment from '@/pages/AISmartAssignment';
import AINextBestAction from '@/pages/AINextBestAction';
import AILeadScoring from '@/pages/AILeadScoring';
import AIPlaybookInsights from '@/pages/AIPlaybookInsights';
import AIAgentPlaybook from '@/pages/AIAgentPlaybook';
import AIDashboard from '@/pages/AIDashboard';
import AIChatAssistant from '@/pages/AIChatAssistant';
import AgentAssignmentOrchestrationSettings from '@/pages/AgentAssignmentOrchestrationSettings';
import AutomatedReportSettings from '@/pages/AutomatedReportSettings';
import AICallScheduling from '@/pages/AICallScheduling';
import ReportingDashboard from '@/pages/ReportingDashboard';
import LiveChatDashboard from '@/pages/LiveChatDashboard';
import LiveChatWebsites from '@/pages/LiveChatWebsites';
import LiveChatVisitors from '@/pages/LiveChatVisitors';
import LiveChatVisitorDetail from '@/pages/LiveChatVisitorDetail';
import LiveChatChats from '@/pages/LiveChatChats';
import LiveChatCannedResponses from '@/pages/LiveChatCannedResponses';
import LiveChatAnalytics from '@/pages/LiveChatAnalytics';
import LiveChatRules from '@/pages/LiveChatRules';
import ChatFlowConfig from '@/pages/ChatFlowConfig';
import LiveTrafficVisualization from '@/pages/LiveTrafficVisualization';
import MarketingDashboard from '@/pages/MarketingDashboard';
import MarketingDashboardV2 from '@/pages/MarketingDashboardV2';
import AIReportsDashboard from '@/pages/AIReportsDashboard';
import MarketingLists from '@/pages/MarketingLists';
import MarketingSegments from '@/pages/MarketingSegments';
import MarketingTemplates from '@/pages/MarketingTemplates';
import MarketingCampaigns from '@/pages/MarketingCampaigns';
import MarketingCampaignCreator from '@/pages/MarketingCampaignCreator';
import SocialMediaDashboard from '@/pages/SocialMediaDashboard';
import SocialInbox from '@/pages/SocialInbox';
import JourneyList from '@/pages/JourneyList';
import JourneyBuilder from '@/pages/JourneyBuilder';
import FormList from '@/pages/FormList';
import FormBuilder from '@/pages/FormBuilder';
import MarketingSales from '@/pages/MarketingSales';
import Bookings from '@/pages/Bookings';
import Documents from '@/pages/Documents';
import NotificationSettings from '@/pages/NotificationSettings';
import SalesReportingDashboard from '@/pages/SalesReportingDashboard';
import HODDashboard from '@/pages/HODDashboard';
import CompetitionDashboard from '@/pages/CompetitionDashboard';
import CEODashboard from '@/pages/CEODashboard';
import AgentDashboard from '@/pages/AgentDashboard';
import {
  MeetingIntelligenceDashboard,
  MeetingsList,
  MeetingCreate,
  MeetingDetail,
  TaskBoard,
  Repository,
  Integrations as MeetingIntegrations,
  AIInsights,
  MeetingTemplates,
  MeetingAnalytics,
  MeetingCalendar,
  ProjectList,
  ProjectDashboard,
  ParticipantTracking,
  ProjectTimeline,
  MeetingSettings
} from '@/pages/MeetingIntelligence';
import {
  AcademyDashboard,
  CoursesList,
  CourseDetail,
  LessonViewer,
  ExamInterface,
  ExamResult,
  CertificateView,
  CertificateVerify,
  AdminAnalytics,
  Leaderboard,
  CourseEditor,
  LearningPaths,
  LearningPathDetail
} from '@/pages/Academy';
import MeetingRoom from '@/pages/MeetingRoom';
import AppShell from '@/components/AppShell';
// Note: Meeting Intelligence routes are under /meeting-intelligence/*
import AIAssistant from '@/components/AIAssistant';
import ConversationalAI from '@/components/ConversationalAI';
import PWAInstallPrompt from '@/components/PWAInstallPrompt';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Skip auth check if user passed from AuthCallback
  if (location.state?.user) {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-accent border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Check if user has pending role (awaiting admin approval)
  if (user.role === 'pending') {
    return <NoAccessPage />;
  }

  // Force a password change on first login. Admins provision new
  // accounts with a temporary password and the ``must_reset_password``
  // flag set true (see scripts/seed_bdm_users.py). Until the user
  // sets a real password every protected navigation snaps to
  // /first-login. We run this BEFORE the BDM scope check so a BDM
  // user with the flag still goes to /first-login first; once they
  // change their password, normal scoping resumes.
  if (user.must_reset_password && location.pathname !== '/first-login') {
    return <Navigate to="/first-login" replace />;
  }
  // The inverse case — flag is already cleared and the user
  // somehow landed on /first-login — bounce them to the dashboard.
  if (!user.must_reset_password && location.pathname === '/first-login') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// LandingRedirect — first page a logged-in user lands on. We can't
// hardcode /contacts (many roles don't have SALES.CONTACTS granted)
// or /dashboard (narrow roles like indirect_sales might not have
// DASHBOARD.OVERVIEW granted). Instead we read the RBAC nav that
// the backend just returned, pick the first submenu path the user's
// role grants, and redirect there. If nav is still loading, spin.
// If nav is truly empty, show a login-fallback message.
const LandingRedirect = () => {
  const { navigation, loading } = useRBAC();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-accent border-t-transparent rounded-full"></div>
      </div>
    );
  }

  // Pick the first submenu path in the first menu that has any.
  const firstPath = (() => {
    for (const menu of (navigation || [])) {
      const subs = menu.sub_menus || [];
      if (subs.length > 0 && subs[0].route_path) {
        return subs[0].route_path;
      }
    }
    return null;
  })();

  if (firstPath) {
    return <Navigate to={firstPath} replace />;
  }

  // No nav at all — nothing this user is allowed to see. AppShell
  // will render its "No menus assigned" empty state for the sidebar;
  // land on /dashboard so the main pane isn't blank (Dashboard is
  // gated in Dashboard.js if the user really can't access it).
  return <Navigate to="/dashboard" replace />;
};

// RBACRouteGuard — blocks a route when the current user's RBAC nav
// doesn't include it, so removing a permission via the Permission
// Groups page immediately blocks direct-URL access to the page (not
// just hides the sidebar entry). Redirects to the RBAC landing so
// the user lands on something they *are* allowed to see.
const RBACRouteGuard = ({ path, children }) => {
  const { canAccessRoute, loading } = useRBAC();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-accent border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!canAccessRoute(path)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

// Role-based protected route - restricts access to specific roles
const RoleProtectedRoute = ({ children, allowedRoles, redirectTo = '/my-dashboard' }) => {
  const { user } = useAuth();
  
  // Admin roles that have access to everything
  const adminRoles = ['super_admin', 'admin', 'owner', 'account_owner'];
  
  // Define blocked roles for specific dashboards
  const blockedAgentRoles = ['sales_agent', 'marketing_agent', 'customer_relations_agent', 'agent'];
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  // Admin roles have access to everything
  if (adminRoles.includes(user.role)) {
    return children;
  }
  
  // If allowedRoles is specified, check if user's role is in the list
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={redirectTo} />;
  }
  
  // Block agent roles from HOD-level dashboards
  if (blockedAgentRoles.includes(user.role)) {
    return <Navigate to={redirectTo} />;
  }
  
  return children;
};

// Handle OAuth callbacks - check URL hash for session_id
const AppRouter = () => {
  const location = useLocation();
  
  // CRITICAL: Check for session_id synchronously during render
  // This prevents race conditions by processing OAuth callback FIRST
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/join-team" element={<JoinTeam />} />
      {/* First-login forced password change — must sit OUTSIDE the
          /* catch-all so the AppShell doesn't render the sidebar
          behind a half-authenticated user. Still wrapped in
          ProtectedRoute so the user has to actually be logged in.
          The guard inside ProtectedRoute lets this path through
          even when must_reset_password is true. */}
      <Route
        path="/first-login"
        element={
          <ProtectedRoute>
            <FirstLogin />
          </ProtectedRoute>
        }
      />
      <Route path="/shared/:shareToken" element={<SharedProjectView />} />
      <Route path="/shared/doc/:shareToken" element={<SharedDocumentView />} />
      <Route path="/academy/verify/:certificateNumber" element={<CertificateVerify />} />
      <Route path="/meet/:meetingId" element={<MeetingRoom />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<Navigate to="/settings" />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppShell>
              <Routes>
                <Route path="/" element={<LandingRedirect />} />
                <Route path="/dashboard" element={<Dashboard />} />
                {/* Leads Dashboard sub-pages — Direct = internal team owns
                    the lead; Indirect = partner/broker referred the lead. */}
                {/* Leads Dashboard landing/overview — summary of the
                    four sub-pages (Direct/Indirect/Brokerage/Lifecycle). */}
                <Route path="/leads-dashboard" element={<LeadDashboardOverview />} />
                <Route path="/leads-dashboard/direct-sales" element={<DirectSalesDashboard />} />
                <Route path="/leads-dashboard/indirect-sales" element={<IndirectSalesDashboard />} />
                {/* Brokerage Hub — feature inside Indirect Sales. */}
                <Route path="/leads-dashboard/brokerage-hub" element={<BrokerageHub />} />
                <Route path="/leads-dashboard/brokerage-hub/:id" element={<BrokerageDetail />} />
                {/* Customer Master — admin queue for duplicate detail
                    updates and force-duplicate approvals. */}
                <Route path="/admin/duplicate-management" element={<DuplicateManagementDashboard />} />
                {/* Company Car Requests — receptionist + manager queue. */}
                <Route path="/car-requests" element={<CarRequests />} />
                <Route path="/contacts" element={<LeadDashboard />} />
                <Route path="/contacts/new" element={<LeadDashboard />} />
                <Route path="/contacts/old" element={<ContactsOld />} />
                <Route path="/contacts/:contactId" element={<ContactDetail />} />
                <Route path="/calling" element={<Calling />} />
                <Route path="/social" element={<SocialPublishing />} />
                <Route path="/forecast" element={<RevenueForecast />} />
                <Route path="/campaign-creator" element={<AICampaignCreator360 />} />
                <Route path="/campaign-analytics" element={<CampaignAnalytics />} />
                <Route path="/inbox" element={<OmnichannelInbox />} />
                <Route path="/whatsapp" element={<WhatsAppInbox />} />
                <Route path="/channels" element={<ChannelSettings />} />
                <Route path="/hubspot" element={<HubSpotMigration />} />
                <Route path="/real-estate" element={<RealEstate />} />
                <Route path="/brokers" element={<BrokerMaster />} />
                <Route path="/brokers/dedup" element={<BrokerDedupWorkspace />} />
                <Route path="/lead-lifecycle" element={<LeadLifecycleDashboard />} />
                <Route path="/approvals" element={<ApprovalInbox />} />
                {/* Notifications — full-page browse of everything the
                    bell-icon dropdown surfaces. Reached from the
                    "View all" link in the bell footer. */}
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/developers" element={<DeveloperMaster />} />
                <Route path="/lead-assignment" element={<LeadAssignment />} />
                <Route path="/analytics" element={<DealAnalyticsPage />} />
                <Route path="/workflows" element={<Navigate to="/workflows-builder" replace />} />
                <Route path="/workflows-builder" element={<WorkflowsListNew />} />
                <Route path="/workflows-builder/analytics" element={<WorkflowAnalytics />} />
                <Route path="/workflows-builder/history" element={<WorkflowHistory />} />
                <Route path="/workflows-builder/history/:workflowId" element={<WorkflowHistory />} />
                <Route path="/workflows-builder/new" element={<WorkflowBuilder />} />
                <Route path="/workflows-builder/:workflowId" element={<WorkflowBuilder />} />
                <Route path="/visits" element={<SalesVisits />} />
                <Route path="/team" element={<TeamManagement />} />
                <Route path="/users" element={<UserManagement />} />
                {/* /organization (Organization Structure) hidden — its
                    Sales Teams panel now lives inside Organization
                    Dashboard, and full CRUD lives on /team. Direct URL
                    entry bounces to Team Management so no dead links. */}
                <Route path="/organization" element={<Navigate to="/team" replace />} />
                <Route path="/roles" element={<RoleManagement />} />
                <Route path="/admin/roles" element={<EnhancedRoleManagement />} />
                <Route path="/admin/menus" element={<MenuManagement />} />
                {/* User Mapping Settings — isolated admin page for
                    reports_to / visible_to_dashboards mapping. */}
                <Route path="/admin/user-mapping" element={<UserMappingSettings />} />
                <Route path="/admin/permission-groups" element={<PermissionGroups />} />
                <Route path="/admin/lead-statuses" element={<LeadStatusManagement />} />
                <Route path="/admin/lifecycle-stages" element={<LifecycleStageManagement />} />
                <Route path="/admin/custom-fields-tags" element={<CustomFieldsTagsManagement />} />
                <Route path="/admin/ai-assignment" element={<AIAssignmentSettings />} />
                <Route path="/admin/ai-followup" element={<WhatsAppFollowupSettings />} />
                <Route path="/admin/whatsapp-automation" element={<WhatsAppAutomation />} />
                <Route path="/admin/sla-settings" element={<SLASettings />} />
                <Route path="/admin/response-time-tracker" element={<ResponseTimeTracker />} />
                <Route path="/admin/ai-intelligence" element={<AIIntelligence />} />
                <Route path="/admin/ai-intelligence/smart-assignment" element={<AISmartAssignment />} />
                <Route path="/admin/ai-intelligence/next-best-action" element={<AINextBestAction />} />
                <Route path="/admin/ai-intelligence/lead-scoring" element={<AILeadScoring />} />
                <Route path="/admin/ai-intelligence/agent-playbook" element={<AIAgentPlaybook />} />
                <Route path="/admin/ai-intelligence/playbook-insights" element={<AIPlaybookInsights />} />
                <Route path="/admin/ai-intelligence/dashboard" element={<AIDashboard />} />
                <Route path="/admin/assignment-orchestrator" element={<AgentAssignmentOrchestrationSettings />} />
                <Route path="/admin/automated-reports" element={<AutomatedReportSettings />} />
                <Route path="/admin/ai-call-scheduling" element={<AICallScheduling />} />
                {/* Reporting */}
                <Route path="/reporting" element={<ReportingDashboard />} />
                <Route path="/reporting/sales" element={<ReportingDashboard />} />
                <Route path="/reporting/marketing" element={<ReportingDashboard />} />
                <Route path="/reporting/activity" element={<ReportingDashboard />} />
                
                {/* Sales Agent Reporting Dashboard */}
                <Route path="/my-dashboard" element={<SalesReportingDashboard />} />
                
                {/* HOD Dashboard - Blocked for agent roles */}
                <Route path="/hod-dashboard" element={
                  <RoleProtectedRoute>
                    <HODDashboard />
                  </RoleProtectedRoute>
                } />
                
                {/* Sales Competition Dashboard */}
                <Route path="/competition" element={<CompetitionDashboard />} />
                
                {/* CEO Dashboard - Blocked for agent and HOD roles */}
                <Route path="/ceo" element={
                  <RoleProtectedRoute allowedRoles={['ceo', 'super_admin', 'admin', 'owner', 'account_owner']}>
                    <CEODashboard />
                  </RoleProtectedRoute>
                } />
                
                {/* AI Hub Routes */}
                <Route path="/ai-dashboard" element={<AIDashboard />} />
                <Route path="/ai/lead-scoring" element={<AILeadScoring />} />
                <Route path="/ai/smart-assignment" element={<AISmartAssignment />} />
                <Route path="/ai/next-best-action" element={<AINextBestAction />} />
                <Route path="/ai/playbooks" element={<AIAgentPlaybook />} />
                <Route path="/ai/chat-assistant" element={<AIChatAssistant />} />
                
                {/* Admin Route Aliases */}
                <Route path="/admin/users" element={<UserManagement />} />
                <Route path="/admin/assignment-rules" element={<AgentAssignmentOrchestrationSettings />} />
                <Route path="/admin/org-modules" element={<OrganizationModulesManagement />} />
                <Route path="/channel-settings" element={<ChannelSettings />} />
                
                {/* Live Chat Monitoring - Support both /live-chat and /marketing/live-chat paths */}
                <Route path="/live-chat" element={<LiveChatDashboard />} />
                <Route path="/live-chat/websites" element={<LiveChatWebsites />} />
                <Route path="/live-chat/chats" element={<LiveChatChats />} />
                <Route path="/live-chat/chats/:chatId" element={<LiveChatChats />} />
                <Route path="/live-chat/visitors" element={<LiveChatVisitors />} />
                <Route path="/live-chat/analytics" element={<LiveChatAnalytics />} />
                <Route path="/marketing/live-chat" element={<LiveChatDashboard />} />
                <Route path="/marketing/live-chat/websites" element={<LiveChatWebsites />} />
                <Route path="/marketing/live-chat/websites/new" element={<LiveChatWebsites />} />
                <Route path="/marketing/live-chat/websites/:websiteId" element={<LiveChatWebsites />} />
                <Route path="/marketing/live-chat/websites/:websiteId/flow-config" element={<ChatFlowConfig />} />
                <Route path="/live-chat/websites/:websiteId/flow-config" element={<ChatFlowConfig />} />
                <Route path="/marketing/live-chat/visitors" element={<LiveChatVisitors />} />
                <Route path="/marketing/live-chat/visitors/:visitorId" element={<LiveChatVisitorDetail />} />
                <Route path="/marketing/live-chat/chats" element={<LiveChatChats />} />
                <Route path="/marketing/live-chat/chats/:chatId" element={<LiveChatChats />} />
                <Route path="/marketing/live-chat/canned-responses" element={<LiveChatCannedResponses />} />
                <Route path="/marketing/live-chat/analytics" element={<LiveChatAnalytics />} />
                <Route path="/marketing/live-chat/rules" element={<LiveChatRules />} />
                <Route path="/marketing/live-chat/traffic" element={<LiveTrafficVisualization />} />
                {/* Marketing KPI Dashboard — Awareness + Performance + Funnel + AI insights */}
                <Route path="/marketing-dashboard" element={<MarketingDashboardV2 />} />
                {/* AI Reports — Mid-Day + EOD with 3 read levels (CEO/HOD/HR) */}
                <Route path="/ai-reports" element={<AIReportsDashboard />} />
                {/* Marketing Automation */}
                <Route path="/marketing/automation" element={<MarketingDashboard />} />
                <Route path="/marketing/lists" element={<MarketingLists />} />
                <Route path="/marketing/segments" element={<MarketingSegments />} />
                <Route path="/marketing/templates" element={<MarketingTemplates />} />
                <Route path="/marketing/campaigns" element={<MarketingCampaigns />} />
                <Route path="/marketing/campaigns/new" element={<MarketingCampaignCreator />} />
                <Route path="/marketing/campaigns/:id" element={<MarketingCampaignCreator />} />
                <Route path="/marketing/campaigns/:id/edit" element={<MarketingCampaignCreator />} />
                {/* Social Media Management */}
                <Route path="/marketing/social" element={<SocialMediaDashboard />} />
                <Route path="/marketing/social/inbox" element={<SocialInbox />} />
                <Route path="/marketing/social/*" element={<SocialMediaDashboard />} />
                {/* Marketing Journey Builder */}
                <Route path="/marketing/journeys" element={<JourneyList />} />
                <Route path="/marketing/journeys/new" element={<JourneyBuilder />} />
                <Route path="/marketing/journeys/:journeyId" element={<JourneyBuilder />} />
                {/* Marketing Forms */}
                <Route path="/marketing/forms" element={<FormList />} />
                <Route path="/marketing/forms/new" element={<FormBuilder />} />
                <Route path="/marketing/forms/:formId" element={<FormBuilder />} />
                {/* Marketing Sales - UTM Tracker */}
                <Route path="/marketing/sales" element={<MarketingSales />} />
                {/* WhatsApp Workflow Builder */}
                <Route path="/communication/workflow-builder" element={<WorkflowDashboard />} />
                <Route path="/communication/workflow-builder/new" element={<WhatsAppWorkflowBuilder />} />
                <Route path="/communication/workflow-builder/:workflowId" element={<WhatsAppWorkflowBuilder />} />
                {/* Meeting Intelligence */}
                <Route path="/meeting-intelligence" element={<MeetingIntelligenceDashboard />} />
                <Route path="/meeting-intelligence/projects" element={<ProjectList />} />
                <Route path="/meeting-intelligence/projects/:projectId" element={<ProjectDashboard />} />
                <Route path="/meeting-intelligence/projects/:projectId/activity-timeline" element={<ProjectTimeline />} />
                <Route path="/meeting-intelligence/meetings" element={<MeetingsList />} />
                <Route path="/meeting-intelligence/meetings/new" element={<MeetingCreate />} />
                <Route path="/meeting-intelligence/meetings/:meetingId" element={<MeetingDetail />} />
                <Route path="/meeting-intelligence/meetings/:meetingId/participants" element={<ParticipantTracking />} />
                <Route path="/meeting-intelligence/tasks" element={<TaskBoard />} />
                <Route path="/meeting-intelligence/tasks/board" element={<TaskBoard />} />
                <Route path="/meeting-intelligence/repository" element={<Repository />} />
                <Route path="/meeting-intelligence/integrations" element={<MeetingIntegrations />} />
                <Route path="/meeting-intelligence/insights" element={<AIInsights />} />
                <Route path="/meeting-intelligence/templates" element={<MeetingTemplates />} />
                <Route path="/meeting-intelligence/analytics" element={<MeetingAnalytics />} />
                <Route path="/meeting-intelligence/calendar" element={<MeetingCalendar />} />
                <Route path="/meeting-intelligence/settings" element={<MeetingSettings />} />
                {/* Treppan Academy LMS */}
                <Route path="/academy" element={<AcademyDashboard />} />
                <Route path="/academy/courses" element={<CoursesList />} />
                <Route path="/academy/courses/:courseId" element={<CourseDetail />} />
                <Route path="/academy/courses/:courseId/lessons/:lessonId" element={<LessonViewer />} />
                <Route path="/academy/courses/:courseId/exam" element={<ExamInterface />} />
                <Route path="/academy/courses/:courseId/result" element={<ExamResult />} />
                <Route path="/academy/certificates/:certificateId" element={<CertificateView />} />
                <Route path="/academy/leaderboard" element={<Leaderboard />} />
                <Route path="/academy/admin/analytics" element={<AdminAnalytics />} />
                <Route path="/academy/admin/courses/new" element={<CourseEditor />} />
                <Route path="/academy/admin/courses/:courseId/edit" element={<CourseEditor />} />
                <Route path="/academy/paths" element={<LearningPaths />} />
                <Route path="/academy/paths/:pathId" element={<LearningPathDetail />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/profile" element={<ProfileSettings />} />
                <Route path="/integrations" element={<Integrations />} />
                <Route path="/whatsapp-settings" element={<WhatsAppSettings />} />
                <Route path="/email-settings" element={<EmailSettings />} />
                <Route path="/settings/integrations" element={<SocialAdsSettings />} />
                <Route path="/settings/social-ads" element={<SocialAdsSettings />} />
                <Route path="/organizations" element={<OrganizationManagement />} />
                <Route path="/organizations/modules" element={<OrganizationModulesManagement />} />
                <Route path="/organizations/:orgId" element={<OrganizationDashboard />} />
                <Route path="/project-catalog" element={<ProjectCatalog />} />
                {/* Sales - Bookings & Transactions */}
                <Route path="/bookings" element={<Bookings />} />
                {/* Properties - Documents */}
                <Route path="/documents" element={<Documents />} />
                {/* Settings - Notifications (RBAC-guarded so direct URL
                    access still respects the Notifications permission) */}
                <Route
                  path="/settings/notifications"
                  element={
                    <RBACRouteGuard path="/settings/notifications">
                      <NotificationSettings />
                    </RBACRouteGuard>
                  }
                />
              </Routes>
              {/* AIAssistant removed - using CRMAssistant in contact detail page instead */}
            </AppShell>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <LanguageProvider>
          <RBACProvider>
            <LiveChatNotificationProvider>
              <NotificationSoundProvider>
                <BrowserRouter>
                  {/* Toast position. Top-right collided with the search
                      bar, the notification bell badge and the user menu
                      in the topbar — new-notification toasts kept covering
                      those exact controls. Bottom-right keeps the navbar
                      clear; the larger `offset` lifts the stack ~100px
                      above the page edge so toasts don't sit right on top
                      of any sticky footer or browser chrome. `closeButton`
                      adds an X for manual dismiss. */}
                  <Toaster position="bottom-right" closeButton offset={100} />
                  <AppRouter />
                  <PWAInstallPrompt />
                </BrowserRouter>
              </NotificationSoundProvider>
            </LiveChatNotificationProvider>
          </RBACProvider>
        </LanguageProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;